import { Helmet } from 'react-helmet-async';

export default function SEO({
    title = 'OV Hairstyle - Salon de Coiffure à Domicile | Kinshasa',
    description = 'Service de coiffure premium à domicile à Kinshasa. Coupes, colorations, soins capillaires. Réservez votre rendez-vous en ligne.',
    image = '/images/og-image.jpeg',
    url = 'https://ov-hairstyle.vercel.app',
    type = 'website'
}) {
    return (
        <Helmet>
            {/* Meta Tags Basiques */}
            <meta charSet="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="author" content="OV Hairstyle" />
            <meta name="keywords" content="coiffure, salon à domicile, Kinshasa, coupe, coloration, soins capillaires, balayage, lissage brésilien" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="French" />
            <meta name="revisit-after" content="7 days" />

            {/* Favicon */}
            <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
            <link rel="apple-touch-icon" href="/apple-touch-icon.svg" type="image/svg+xml" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content="OV Hairstyle" />
            <meta property="og:locale" content="fr_FR" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:creator" content="@OVHairstyle" />

            {/* Canonical */}
            <link rel="canonical" href={url} />

            {/* Theme Color */}
            <meta name="theme-color" content="#8B5A8E" />
        </Helmet>
    );
}
